<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-delete"
        @click="bulkDelete"
      >删除</el-button>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-refresh"
        @click="getList()"
      >刷新</el-button>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 1311px"
      height="calc(100vh - 240px )"
      size="mini"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="name" label="名称" width="200" />
      <el-table-column prop="content" label="内容" width="260" />
      <el-table-column prop="crmTicketName" label="CRM票券名称" width="200" />
      <el-table-column label="有效时间" width="300">
        <template slot-scope="scope">
          <div v-if="scope.row.effectiveType === 1">
            {{ scope.row.effectiveStartTime }} ~
            {{ scope.row.effectiveEndTime }}
          </div>
          <div v-if="scope.row.effectiveType === 2">
            {{ scope.row.effectiveDayCount }}天
          </div>
        </template>
      </el-table-column>
      <el-table-column label="可分享次数" width="100">
        <template slot-scope="scope"> {{ scope.row.share_count }} 次 </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <div :style="{ color: scope.row.status ? '#67C23A' : '#e74c3c' }">
            {{ scope.row.status ? "启用" : "禁用" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="220">
        <template slot-scope="scope">
          {{
            $parseTime(new Date(scope.row.createdAt), "{y}-{m}-{d} {h}:{i}:{s}")
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="open('edit', scope.row)"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="isEdit ? '修改' : '添加'"
      :visible.sync="dialogVisible"
      width="1200px"
      :close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="formData" label-width="220px" size="mini">
        <el-form-item label="CRM票券名称">
          <el-select
            v-model="formData.crmTicketId"
            placeholder="请选择CRM票券"
            :disabled="isEdit"
            @change="changeCrmTicket($event)"
          >
            <el-option
              v-for="item in crmTicketList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input
            v-model="formData.name"
            placeholder="请输入名称"
            style="width: 200px"
            size="mini"
          />
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            v-model="formData.content"
            placeholder="请输入内容"
            style="width: 200px"
            size="mini"
            :disabled="isEdit"
          />
        </el-form-item>

        <el-form-item label="有效期类型">
          <el-radio
            v-model="formData.effectiveType"
            :label="1"
            :disabled="isEdit"
          >固定</el-radio>
          <el-radio
            v-model="formData.effectiveType"
            :label="2"
            :disabled="isEdit"
          >动态</el-radio>
        </el-form-item>
        <el-form-item v-if="formData.effectiveType === 1" label="有效上架时间">
          <el-date-picker
            v-model="effectiveTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :disabled="isEdit"
          />
        </el-form-item>
        <el-form-item v-if="formData.effectiveType === 2" label="有效天数">
          <el-input-number
            v-model="formData.effectiveDayCount"
            :min="1"
            :disabled="isEdit"
          />
        </el-form-item>
        <el-form-item label="可分享次数">
          <el-input-number
            v-model="formData.share_count"
            :min="0"
            :disabled="isEdit"
          />
        </el-form-item>
        <el-form-item label="使用说明">
          <vue-ueditor-wrap
            v-if="dialogVisible"
            :key="editorKey"
            v-model="formData.usageInstructions"
            :config="editorConfig"
          />
          <div class="instructions-tip">请写明领取方式、使用期限、如何使用。保存后，已领取的同类票券也会显示最新说明。</div>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio v-model="formData.status" :label="1">启用</el-radio>
          <el-radio v-model="formData.status" :label="0">禁用</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button
            style="margin-right: 10px"
            @click="dialogVisible = false"
          >取消</el-button>
          <el-popconfirm
            title="是否确定保存？"
            @onConfirm="isEdit ? edit() : add()"
          >
            <el-button
              slot="reference"
              type="primary"
              class="edit-button"
            >保存</el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import {
  getTicketManList,
  addTicketMan,
  updateTicketMan,
  removeTicketMan,
  getCrmlist
} from '@/api/ticketMan.js'
import { parseTime } from '@/utils'
export default {
  name: 'Order',
  components: { VueUeditorWrap },
  data() {
    return {
      loading: false,
      total: 0,
      showtabelData: [], // 表单数据
      multipleSelection: [], // 选中项
      dialogVisible: false, // 弹窗标识
      formData: {
        name: '',
        content: '',
        usageInstructions: '',
        crmTicketName: '',
        effectiveType: 1,
        effectiveStartTime: '',
        effectiveEndTime: '',
        effectiveDayCount: 0,
        share_count: 0,
        status: 1
      }, // 选中项
      effectiveTime: [],
      isEdit: false,
      editorKey: 0,
      editorConfig: {
        UEDITOR_HOME_URL: '/ueditor/',
        autoHeightEnabled: false,
        initialFrameHeight: 300,
        initialFrameWidth: '100%',
        maximumWords: 20000,
        enableAutoSave: false,
        serverUrl: '/gw/admin/operate/uploadBanner',
        headers: { Authorization: localStorage.getItem('token') },
        imageActionName: 'uploadimage',
        imageAllowFiles: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
        imageUrlPrefix: '',
        imagePathFormat: '',
        imageMaxSize: 1024 * 1000 * 10,
        toolbars: [[
          'undo', 'redo', '|', 'bold', 'italic', 'underline', 'forecolor',
          'fontsize', 'removeformat', '|', 'insertorderedlist', 'insertunorderedlist',
          'justifyleft', 'justifycenter', 'justifyright', '|', 'insertimage'
        ]]
      },
      crmTicketList: []
    }
  },
  mounted() {
    this.getList()

    getCrmlist().then((res) => {
      console.log('res', res)
      const arr = res.basic_information?.manual_coupons || []
      arr.forEach((item) => {
        this.crmTicketList.push({
          label: item.name,
          value: Number(item.id),
          external_system_id: item.external_system_id
        })
      })
    })
  },
  methods: {
    toArrayEvent(item) {
      return [item]
    },
    // 获取表单信息
    getList() {
      this.loading = true
      getTicketManList()
        .then((res) => {
          this.showtabelData = res
          this.total = res.total
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 关闭添加弹窗
    handleClose() {
      // console.log(11)
      this.active = {}
    },
    initData() {
      this.formData = {
        name: '',
        content: '',
        usageInstructions: '',
        crmTicketName: '',
        effectiveType: 1,
        effectiveStartTime: '',
        effectiveEndTime: '',
        effectiveDayCount: 0,
        share_count: 0,
        status: 1
      }
    },
    open(type, item) {
      console.log(type, item)
      this.initData()
      this.editorKey += 1
      this.effectiveTime = []
      if (type == 'add') {
        this.isEdit = false
        this.dialogVisible = true
      } else if (type == 'edit') {
        this.isEdit = true
        this.formData = { ...this.formData, ...item, usageInstructions: item.usageInstructions || '' }
        this.effectiveTime = [
          this.formData.effectiveStartTime,
          this.formData.effectiveEndTime
        ]
        this.dialogVisible = true
      }
    },
    // 添加
    add() {
      const [startTime, endTime] = this.effectiveTime
      this.formData.effectiveStartTime = parseTime(
        startTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        endTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      console.log(this.formData)
      addTicketMan(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('添加成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 修改
    edit() {
      const [startTime, endTime] = this.effectiveTime
      this.formData.effectiveStartTime = parseTime(
        startTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        endTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      updateTicketMan(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('修改成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 批量删除
    bulkDelete() {
      console.log(this.multipleSelection, 'this.multipleSelection')
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          roundButton: true
        })
          .then(() => {
            const ids = this.multipleSelection.map((item) => {
              return item.id
            })
            removeTicketMan({ ids })
              .then((res) => {
                this.$message.success('删除成功')
                this.getList()
              })
              .catch((err) => {
                this.$message.error(err)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        this.$message.warning('请勾选要删除的选项')
      }
    },
    changeCrmTicket(value) {
      const item = this.crmTicketList.find((item) => item.value === value)
      this.formData.crmTicketName = item.label || ''
      this.formData.external_system_id = item.external_system_id || ''
    }
  }
}
</script>
<style lang="scss" scoped>
.instructions-tip {
  color: #909399;
  font-size: 12px;
  line-height: 20px;
  margin-top: 8px;
}
.head_search {
  display: flex;
  // justify-content: space-around;
  width: 100%;
  .item_warp {
    display: flex;
    .el-checkbox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #525252;
    }
  }
}
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.isSyn {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
